import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

// Routes a `special`-role user is allowed to render. Everything else is
// redirected to /estimates which is their effective home page.
const SPECIAL_ROLE_ALLOWED = [
  "/estimates",
  "/reports",
  "/reports/project-pnl",
  "/reports/branch-pnl",
  "/reports/vertical-pnl",
  "/reports/warehouse-inventory",
  "/reports/cost-centre-expense",
  "/reports/company-pnl",
  "/reports/issued-statement",
  "/approvals",
];

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F7F8]">
        <div className="text-slate-500 uppercase tracking-[0.3em] text-xs">Loading Radiants PrimeWork…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  // Lock the "special" persona inside its allow-list. Direct-URL attempts to
  // dashboard / masters / vouchers etc. are bounced to /estimates which is the
  // landing page for this role.
  if (user.role === "special") {
    const path = location.pathname;
    const isHome = path === "/" || path === "";
    const isAllowed = SPECIAL_ROLE_ALLOWED.some((p) => path === p || path.startsWith(`${p}/`));
    if (isHome || !isAllowed) {
      return <Navigate to="/estimates" replace />;
    }
  }
  return children;
}
